<script setup>
import { computed } from 'vue';

import HeadingTitle from '@/components/layouts/HeadingTitle.ce.vue';
import TariffsTable from '@/components/layouts/TariffsTable.ce.vue';
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';
import { personalizedTariffs } from '@/tariffs/personalized_tariffs';
import TariffsTableRowGroup from "@/components/layouts/TariffsTableRowGroup.ce.vue";

const getRowGroups = computed(() => personalizedTariffs.getRows);
</script>

<template>
    <HeadingTitle>
        <TranslationValue id="page3_heading_personalised_lt_phr" />
    </HeadingTitle>

    <p class="mb-6">
        <TranslationValue id="page3_expla_adapt_costs" />
    </p>

    <TariffsTable id="personalized-tariffs">
        <template #thead>
            <th scope="col" class="px-6 py-3"></th>
            <th scope="col" class="px-6 py-3 text-center">
                <TranslationValue id="page3_your_preference" />
            </th>
            <th scope="col" class="px-6 py-3 text-center">
                <TranslationValue id="page3_difference_with_standard" />
            </th>
        </template>
        <template #tbody>
            <TariffsTableRowGroup :row-groups="getRowGroups()"/>
        </template>
    </TariffsTable>
</template>
